import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "285",
  "slug": "spot-argentina-from-satellite-imagery",
  "title": "How to Recognise Argentina in Satellite Images",
  "excerpt": "East of the Andes, the Pampas form a broad lowland around the Río de la Plata.",
  "date": "2026-05-13",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/argentina.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "East of the Andes, the Pampas form a broad lowland around the Río de la Plata. Farther south, Patagonia has a much drier appearance. On the western edge, mountain ridges and lakes mark the approach to the Andes. The north-south change matters more than any single field pattern."
    },
    {
      "type": "heading",
      "text": "The Pampas and Patagonia"
    },
    {
      "type": "paragraph",
      "text": "Follow the Andes south on the overview, then compare land immediately east and west of the range. Choose two views at the same scale so the contrast in terrain is visible."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Uruguay shares the grassland and farming landscapes around the Río de la Plata. Chile shares the Andes. Use the mountain front, nearby coast, and the direction of the river system together before selecting a country."
    }
  ],
  "imageAlt": "Argentina regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
